import * as React from 'react'

const SvgArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8 2.8l-1 1 5.4 5.5H1v1.4h15.2l-5.4 5.5 1 1L19 10l-7.2-7.2z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowRightIcon
